import { defineComponent as _defineComponent } from 'vue'
import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import Modal from "@/components/ui/Modal.vue";
  import { computed, ref, PropType } from "vue";
  import plural from "@/features/plural";
  import store from "@/store";
  import { ImportedListingInterface } from "@/types/ImportedListingInterface";
  import { useToast } from "vue-toastification";
  interface Address {
    street: string;
    streetNumber?: number;
    lotNumber?: number;
    state?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectImportedListingModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    listings: {
      type: Array as PropType<ImportedListingInterface[]>,
      default: () => {
        return [];
      },
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const loading = ref(false);
  const emits = __emit;
  const toast = useToast();
  const props = __props;
  const onSubmit = () => {
    const selectedListings = props.listings.filter(
      ({ isSelected }: ImportedListingInterface) => isSelected
    );

    if (!selectedListings.length) {
      toast.error("Please select at least one listing");
      return;
    }

    loading.value = true;
    store
      .dispatch("listing/createImportedListings", {
        listings: selectedListings,
      })
      .then(() => {
        emits("close");
        toast.success("Listings imported successfully");
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const getListingsSelectedCount = computed(() => {
    return props.listings.filter(
      (listing: ImportedListingInterface) => listing.isSelected
    ).length;
  });

  function getLabel({ address }: { address: Address }): string {
    const { street, streetNumber, lotNumber, state } = address;
    const parts: string[] = [street];

    if (streetNumber) {
      parts.push(` ${streetNumber}`);
    }

    if (lotNumber) {
      parts.push(`, Lot ${lotNumber}`);
    }

    if (state) {
      parts.push(`, ${state}`);
    }

    return parts.join("");
  }

  const close = () => {
    emits("close");
  };

const __returned__ = { loading, emits, toast, props, onSubmit, getListingsSelectedCount, getLabel, close, CheckboxInput, Modal, computed, ref, PropType, get plural() { return plural }, get store() { return store }, get ImportedListingInterface() { return ImportedListingInterface }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})